module.exports = __webpack_public_path__ + "img/tag-03.313fe4a2.svg";